import { Box } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

interface GradientButtonProps {
  label: string
  onClick?: () => void
}

const useStyles = makeStyles({
  gradientButton: {
    borderRadius: '16px',
    width: 'auto',
    padding: 8  ,
    fontSize: 13,
    border: 'none',
    color: 'white',
    display: 'flex',
    background: "linear-gradient(90deg, #1791B2 0%, #1FB069 100%)",
    justifySelf: 'flex-start',
    cursor: (props: any) => props.onClick ? 'pointer' : 'default'
  }
})

export function GradientButton({ label, onClick }: GradientButtonProps){
  const classes = useStyles({ onClick })
  
  return (
    <Box component={"button"} onClick={onClick} className={classes.gradientButton}>
      {label}
    </Box>
  )
}